import React, { Component } from 'react'
import {
  Header,
  Segment,
  Container,
  Item,
  Grid,
  Image,
} from 'semantic-ui-react'
import {Link} from "react-scroll";

import Speaker from '../components/speaker.js'
import '../styles/mou-2.css'
import {abstract1,abstract2,abstract3,abstract4,abstract5, abstract6, abstract7, abstract8,
abstract9, abstract10, abstract11, abstract12, abstract13, abstract14, abstract15, abstract16} from "../secrets/abstract2.js"

  

class MoU_2 extends Component {

    render () {

      return (

        <div className='mainWrapper' id="top">

          <div className="mainimg2">
            <Container textAlign="center">

              <div className="mainHeader">
                <h1 size="huge" className='h1'>Mysteries of the Universe - II </h1>
             
                <p className="date">(Jan 09<sup>th</sup> to May 08<sup>th</sup>, 2021)</p>
             
                <h2 className='h2' id="h2">
                Presented by Institute Lecture Series committee, in collaboration with the Indian Physics Association, 
                Roorkee Chapter and the Student's Technical Council (The Physics and Astronomy Club), IIT Roorkee
                </h2>

              </div>

              
                 
               <div className = "arrow bounce start">
               <Link
                to = "may"
                spy = {true}
                smooth = {true}
                duration = {2500}
               >
                 <span className = "fa fa-arrow-down fa-3x" id="ba"/>
                 </Link>
               </div>
              
               
            </Container>
          </div>
          <div id="about"></div>
          
          <div class="about2">
            <div class="ui horizontal divider" id="lecture">Brief about the lectures </div>
            
            <div class="desp">
              <p>
              The Institute Lecture Series Committee, in collaboration with Professor T. V. Ramakrishnan 
              (FRS; Distinguished Associate, Center for Condensed Matter Theory at Indian Institute of Science, Bengaluru) 
              along with the Students' Technical Council (the Physics and Astronomy Club, in particular) and the Indian Physics 
              Association, Roorkee Chapter, is delighted to bring you (Mysteries of the Universe Institute Lecture Series) MOU ILS-II, 
              an online lecture series covering the frontiers of Physics and Astronomy, like Quantum Mechanics, 
              Condensed Matter Physics, Astrophysics and Cosmology.
              </p> 
              <p> 
              In these lectures, we shall be interacting with some of the biggest names in Physics of our times. 
              Join us as we go on a beautiful and exhilarating journey into the most profound and exciting aspects of 
              Theoretical physics, Cosmology and Condensed Matter.
              </p>
            </div> 
          </div>
         <br/><br/>

          <div className="speaker2" id="speaker"> 

            <div id="esh">
              <Header as="h1" size="huge" id="lecture1">
                LECTURE TIMELINE
              </Header>
            </div>
            
            <div id="jan"></div>
            
            <div class="hd">
              <div class="ui horizontal divider" id="hd"> Talks in January-</div>
            </div>

            <Container>
             <Segment padded textAlign="left" color="red"> 
                <Item.Group divided>
                
                  <Speaker
                    name="Anthony James Leggett"
                    urlImage={require('../resources/photos/mou-2/1.jpg')}
                    title="Does the everyday world really obey Quantum Mechanics?"
                    description= {[ 
                      <b> Nobel Laureate (2003)</b> ,
                      "; John D. and Catherine T. MacArthur Professor Emeritus of Physics, University of Illinois, Urbana Champaign"
                    ]}
                    time="Jan-9, 7:30 PM (IST) (UTC + 5:30)"
                    abstract={abstract1}
                    urlPoster={require('../resources/posters/mou-2/1.jpg')}
                    urlInfo="https://www.nobelprize.org/prizes/physics/2003/leggett/facts/"
                    urlY="https://www.youtube.com/watch?v=HBBkOqHGcjs"
                    urlPpt="https://drive.google.com/file/d/1uyMEYUQhuI9VimYHjNHXtTkVW6VVaLe1/view?usp=sharing"
                  />

                  <Speaker
                    name="F. Duncan M. Haldane"
                    urlImage={require('../resources/photos/mou-2/2.jpg')}
                    title="Topological Quantum Matter, Entanglement, and the Second Quantum Revolution"
                    description={[
                      <b>Nobel Laureate (2016)</b>,
                      "; Sherman Fairchild University Professor of Physics, Princeton University"
                      ]}
                    time="Jan-16, 7:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/2.jpg')}
                    abstract={abstract2}
                    urlInfo="https://www.nobelprize.org/prizes/physics/2016/haldane/facts/"
                    urlY="https://youtu.be/e7Z-eup1f3Q"
                    urlPpt="https://drive.google.com/file/d/1IZLdI6fN0A77vQBj5EQ7g_vKc70o4h-w/view?usp=sharing"
                  />

                </Item.Group>
             </Segment>
            </Container>

            <div id="feb"/>

            <div class="hd">
             <div class="ui horizontal divider" id="hd"> Talks in February-</div>
            </div>

            <Container>
             <Segment padded textAlign="left" color="teal"> 
                <Item.Group divided>
                
                 <Speaker
                    name="Charles Kane"
                    urlImage={require('../resources/photos/mou-2/3.jpg')}
                    title="The Emergence of Topological Quantum Matter"
                    description="Christopher H. Browne Distinguished Professor of Physics,  University of Pennsylvania"
                    time="Feb-16, 7:00 PM (IST) (UTC + 5:30)"
                    abstract={abstract3}
                    urlPpt="https://drive.google.com/file/d/1Aw0QgdqgMHQssij7X7PA_jH8JbiHcYgD/view?usp=sharing"
                    urlPoster={require('../resources/posters/mou-2/3.jpg')}
                    urlInfo="https://breakthroughprize.org/Laureates/1/L3828"
                    urlY="https://youtu.be/4XXeJ-BWt80"

                 />

                  <Speaker
                    name="John Brian Pendry"
                    urlImage={require('../resources/photos/mou-2/4.jpg')}
                    title="Metamaterials open new horizons in electromagnetism"
                    description="Chair in Theoretical Solid State Physics, Faculty of Natural Sciences, Imperial College"
                    time=" Feb-20, 4:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/4.png')}
                    abstract={abstract4}
                    urlInfo="http://kavliprize.org/prizes-and-laureates/laureates/sir-john-b-pendry"
                    urlY="https://youtu.be/nVRwyr2O3gU"
                    urlPpt="https://drive.google.com/file/d/1XJPmaXe2IcVEWunSIDyrxguGsy9ZtvxB/view?usp=sharing"
                  />

                  <Speaker
                    name="Tiruppattur Venkatachalamurti Ramakrishnan"
                    urlImage={require('../resources/photos/mou-2/5.jpg')}
                    title="Four Frontiers of Physics"
                    description={[
                      <b>Padma Shri(2001) </b> ,"; DST Year of Science Chair Professor; Distinguished Associate, Department of Physics, IISc Bangalore Emeritus Professor, BHU Varanasi"
                    ]}
                    time="Feb-27, 4:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/5.png')}
                    abstract={abstract5}
                    urlInfo="https://iiscprofiles.irins.org/profile/16070"
                    urlY="https://youtu.be/KsIKadfmhpU"
                    urlPpt ="https://drive.google.com/file/d/1e1La-WUBdsT-icM8KpEdqpNaOlfcQ0Gn/view?usp=sharing"
                  />        

                </Item.Group>
             </Segment>
            </Container>

            <div id="march"></div>
            <div class="hd">
              <div class="ui horizontal divider" id="hd"> Talks in March </div>
            </div>

            <Container>
             <Segment padded textAlign="left" color="teal"> 
                <Item.Group divided>
                
                 <Speaker
                    name="Subir Sachdev"
                    urlImage={require('../resources/photos/mou-2/6.jpg')}
                    title="A simple model of entangled qubits: how it describes materials in the lab and black holes"
                    description={[<b> Dirac Medalist(2018)</b> 
                      ,"; Herchel Smith Professor of Physics, Harvard"]}
                    time="Mar-13, 7:00 PM (IST) (UTC + 5:30)"
                    abstract={abstract6}
                    urlPoster={require('../resources/posters/mou-2/6.png')}
                    urlInfo="https://www.perimeterinstitute.ca/people/subir-sachdev"
                    urlY="https://youtu.be/tEdFbAYjDtU"
                    urlPpt = "https://drive.google.com/file/d/1HeZCqEXL8O_dd0ngVj5OS9J04leReBYB/view?usp=sharing"
                 />

                  <Speaker
                    name="Thanu Padmanabhan"
                    urlImage={require('../resources/photos/mou-2/7.jpg')}
                    title="The Fluid we call spacetime"
                    description={[ <b> Padma Shri(2007)</b>, "; Distinguished Professor, Inter-University Centre for Astronomy and Astrophysics, Pune "]}
                    time="Mar-20, 4:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/7.png')}
                      abstract={abstract7}
                    urlInfo="https://www.fetzer-franklin-fund.org/media/thanu-padmanabhan/"
                    urlY="https://youtu.be/xmbUNP8BKmA"
                    urlPpt = "https://drive.google.com/file/d/11qCAV0S9P8cccyn4rF4epRsZpy9EIWjF/view?usp=sharing7"
                  />
                  <div id = "ps"></div>
                  <Speaker
                    name="Jainendra K. Jain"
                    urlImage={require('../resources/photos/mou-2/8.jpg')}
                    title="Exotic Emergent Particles in Quantum Condensed Matter"
                    description="Evan Pugh University Professor and Erwin Mueller Professor, Physics
                    Materials Research Institute (MRI), Penn State University"  
                    time="Mar-27, 8:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/8.png')}
                      abstract={abstract8}
                    urlInfo="https://pennstate.pure.elsevier.com/en/persons/jainendra-k-jain"
                    urlY="https://youtu.be/_Us8E2dqOzw"
                    urlPpt="https://drive.google.com/file/d/1zFoJwM2gt3eIamhtDBxfW0A3q6EJlYS7/view?usp=sharing"
                  />
              
                  <Speaker
                    name="Jocelyn Bell Burnell"
                    urlImage={require('../resources/photos/mou-2/16.jpg')}
                    title="Pulsars - a graduate student's tale, and how the discovery has impacted physics"
                    description={[
                    <b>Former (first female) President of the Royal Astronomical Society, the Institute of Physics and the Royal Society of Edinburgh</b> 
                    ,"; Visiting Professor of Astrophysics, Department of Astrophysics, University of Oxford; Chancellor of the University of Dundee, Scotland"]}
                    time="Mar-31, 6:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/9.png')}
                    abstract = {abstract16}
                    urlInfo="https://royalsociety.org/people/jocelyn-bell-burnell-11066/"
                    urlY="https://youtu.be/N2RPt6JnuoM"
                    urlPpt="https://drive.google.com/file/d/1WAwDSiPThAVnU-H5RjNal9R7ps7DRiQW/view?usp=sharing"
                  />

                </Item.Group>
             </Segment>
            </Container>

            <div id="april"/>
            <div class="hd">
              <div class="ui horizontal divider" id="hd"> Talks in April </div>
            </div>

            <Container>
             <Segment padded textAlign="left" color="teal"> 
                <Item.Group divided>
                
                 <Speaker
                  name="Ramesh Narayan"
                  urlImage={require('../resources/photos/mou-2/9.jpg')}
                  title="Astrophysical Black Holes"
                  description="Thomas Dudley Cabot Professor of the Natural Sciences Harvard"
                  time="Apr-3, 7:00 PM (IST) (UTC + 5:30)"
                  abstract={abstract9}
                  urlPoster={require('../resources/posters/mou-2/10.jpg')}
                  urlInfo="https://astronomy.fas.harvard.edu/people/ramesh-narayan"
                  urlY="https://youtu.be/8Sh8tobsDKA"
                  urlPpt="https://drive.google.com/drive/folders/14swlzggD9mszuqNf941qo_qqTb1fZKPu?usp=sharing"
                 />
                    
                  <Speaker
                  name="Shing-Tung Yau"
                  urlImage={require('../resources/photos/mou-2/10.jpg')}
                  title="Theoretical demonstration of existence of black hole due to condensation of matter"
                  description={[
                    <b>Fields Medalist (1982)</b>,
                    "; William Caspar Graustein Professor of Mathematics, Harvard"
                  ]}
                  time="Apr-10, 4:00 PM (IST) (UTC + 5:30)"
                  urlPoster={require('../resources/posters/mou-2/11.png')}
                  abstract={abstract10}
                  urlInfo="https://www.math.harvard.edu/people/yau-shing-tung/"
                  urlY="https://youtu.be/weeQ0a2Xgfc"
                  urlPpt="https://drive.google.com/file/d/1rBf3WAo2B1nxjnKFE8HAAsWYc1RUR0Pq/view?usp=sharing"
                  />
                   
                   <div id = "kr"></div>

                  <Speaker
                  name="Krishna Rajagopal"
                  urlImage={require('../resources/photos/mou-2/11.jpg')}
                  title="Doping and Probing the Original Liquid"
                  description="William A. M. Burden Professor of Physics, Margaret MacVicar Faculty Fellow, Dean for Digital Learning, MIT"
                  time="Apr-14, 6:00 PM (IST) (UTC + 5:30)"
                  abstract={abstract12}
                  urlPoster={require('../resources/posters/mou-2/12.png')}
                  urlInfo="https://physics.mit.edu/faculty/krishna-rajagopal/"
                  urlY="https://youtu.be/ZEQBSQVnN9s"
                  urlPpt="https://drive.google.com/file/d/1BkeCnka3Wo5DcrMKAuL7lhsQcX1m-xM6/view?usp=sharing"
                 />

                  <Speaker
                  name="Kathryn Ann Moler"
                  urlImage={require('../resources/photos/mou-2/13.jpg')}
                  title="Imaging Quantum Rings with Quantum Sensors"
                  description="Vice Provost and Dean of Research, Marvin Chodorow Professor and Professor of Applied Physics and of Physics, Stanford University"
                  time="Apr-17, 8:30 PM (IST) (UTC + 5:30)"
                  abstract={abstract13}
                  urlPoster={require('../resources/posters/mou-2/13.png')}
                  urlInfo="https://profiles.stanford.edu/kathryn-moler"
                  urlY="https://youtu.be/fczCG3gJXh8"
                  urlPpt="https://drive.google.com/file/d/1-NlDuWb5D9_t8Rl9v2zKWuJBEwDejTLu/view?usp=sharing"
                 />

                  <Speaker
                    name="Robbert Dijkgraaf"
                    urlImage={require('../resources/photos/mou-2/12.jpg')}
                    title="Einstein’s Dream — From the Big Bang to Black Holes"
                    description="Director and Leon Levy Professor, IAS Princeton"
                    time="Apr-24, 6:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/14.jpg')}
                    abstract={abstract11}
                    urlInfo="https://www.ias.edu/scholars/dijkgraaf"
                    urlY="https://youtu.be/XF3Suv6PzHA"
                    urlPpt="https://drive.google.com/drive/folders/15dPpNqKdt5Xb7jj31b9GSBukS0fYWYJn?usp=sharing"
                  />

                </Item.Group>
             </Segment>
             </Container>

                <div id="may"/>
                <div class="hd">
                  <div class="ui horizontal divider" id="hd"> Talks in May </div>
                </div>

             <Container>
             <Segment padded textAlign="left" color="teal"> 
                <Item.Group divided>

                  <Speaker
                    name="Renu Malhotra"
                    urlImage={require('../resources/photos/mou-2/14.jpg')}
                    title="Migratory planets and chaos in the young Solar system"
                    description={[
                      "Louise Foucar Marshall Science Research Professor, Regents Professor of Planetary Sciences, University of Arizona and",
                     <b> has asteroid "6698 Malhotra" named after her.</b>
                    ]}
                    time="May-01, 7:30 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/15.png')}
                    abstract={abstract14}
                    urlInfo="https://www.lpl.arizona.edu/~renu/"
                    urlY="https://youtu.be/L9gcxwc4xjI"
                    urlPpt="https://drive.google.com/file/d/1p_qEvVNVWPkyjxJN7c8sn7kPT2QTn0CT/view?usp=sharing"
                  />

                    <Speaker
                    name="Rohini Godbole"
                    urlImage={require('../resources/photos/mou-2/15.jpg')}
                    title="Shedding Light on Dark Matter"
                    description={[
                      <b>Padma Shri(2019)</b>,"; Professor, Centre for High Energy Physics, Indian Institute of Science, Bangalore"
                    ]}
                    time="May-08, 4:00 PM (IST) (UTC + 5:30)"
                    urlPoster={require('../resources/posters/mou-2/16.png')}
                    abstract={abstract15}
                    urlInfo="http://rmgodbole.in/"
                    urlY="https://youtu.be/MMoi80mwxPk"
                    urlPpt="https://drive.google.com/file/d/1QxRUMxpl-dWdU8d76ptL38zQBGUFQCrc/view?usp=sharing"
                   />

                </Item.Group>
             </Segment>
             </Container>
                
              </div>  
          
         
            <Segment padded inverted id="footer">
              <Grid stackable>
                
                  <Grid.Column width={7} floated="left">
                    <Image.Group padded>
                      <Image size="tiny" src={require('../resources/logos/iitr.png')} circular title="IIT Roorkee"/>
                      <Image size="small" src={require('../resources/logos/ipa.png')} title="Indian Physics Association, Roorkee Chapter"  />
                      <Image size="small" src={require('../resources/logos/stc.png')} title="Student's Technical Council, IITR"  />
                      <Image size="tiny" src={require('../resources/logos/paac.png')} circular title="Physics and Astronomy Club, IITR"/>
                    </Image.Group>
                  </Grid.Column>
                  
                  <Grid.Column width="3" floated="right" textAlign="left" verticalAlign="middle">
                    <Header as="h2" id="contact"> Contact</Header>
                    <hr id="divi"/>
                    <Grid.Row>
                      <Header color="teal" as="a"> paac@iitr.ac.in</Header>
                    </Grid.Row>
                    <Grid.Row>
                      <Header color="teal" as="a">aalok.misra@ph.iitr.ac.in</Header>
                    </Grid.Row>
                    
                    
                  </Grid.Column>
              </Grid>
              
            </Segment>
        </div>
      )
    }
  }
  
  export default MoU_2